<script lang="ts" setup>
  import { recaptchaSitekey } from '@/utils/const'
  import { VueRecaptcha } from 'vue-recaptcha'

  const emit = defineEmits(['verify', 'expired'])

  const onVerify = (event: string) => {
    emit('verify', event)
  }
  const onExpired = () => {
    emit('expired')
  }
</script>

<template>
  <VueRecaptcha @expired="onExpired" @verify="onVerify" :sitekey="recaptchaSitekey" />
</template>
